import { AuthService } from '@myosh/myosh-login';
import { AboutInfoModal } from '@myosh/odin-components';
import React from 'react';
import { useGetCurrentSchemaInfoQuery } from '../../redux/config/current-schema-api';
import { useAppDispatch } from '../../redux/hooks';
import { removeHierarchyFilters } from '../../redux/slices/globalFilter/GlobalFilterHierarchySlice';
import { removeGlobalDateFilters } from '../../redux/slices/globalFilter/global-dates-filter-slice';

type AboutMenuOptionType = {
  setShowAboutInfo: (visible: boolean) => void;
  showAboutInfo: boolean;
};
export const AboutMenuOption = ({ showAboutInfo, setShowAboutInfo }: AboutMenuOptionType) => {
  const dispatch = useAppDispatch();
  const { data: schemaInfo } = useGetCurrentSchemaInfoQuery();
  const handleLogout = () => {
    const authService = new AuthService();
    authService.logout();
    dispatch(removeGlobalDateFilters());
    dispatch(removeHierarchyFilters());
  };
  const closeAboutInfo = () => {
    setShowAboutInfo(false);
  };

  return (
    <AboutInfoModal
      currentSchema={{ text: schemaInfo?.schema || 'n/a' }}
      isAboutInfoOpen={showAboutInfo}
      showLogoutButton
      onClose={closeAboutInfo}
      onLogout={handleLogout}
      schemaTimeZone={schemaInfo?.['time-zone']}
      {...schemaInfo}
      version={process.env.REACT_APP_VERSION}
    />
  );
};
